<template>
  <BasePageContainer class="page goal goal-add pt-5 pb-10">
    <div class="page__head edit-head fixed-top p-3">
      <h1 class="edit-head__heading">
        <img
          src="@/assets/images/icon_flag-w.svg"
          class="img-fluid edit-head__icon mr-2">
        ノートの作成
      </h1>
    </div>
    <GoalForm
      :goal-object="goal"
      :is-lock-goal="lockGoalOption"
      :non-field-error="nonFieldError"
      @onClickSave="saveGoal" />
  </BasePageContainer>
</template>

<script>
import GoalForm from '@/components/view/GoalForm.vue'
import format from 'date-fns/format'
export default {
  components: {
    GoalForm
  },
  data() {
    return {
      goal: {
        name: '',
        startDate: format(new Date(), 'yyyy-MM-dd'),
        endDate: '',
        goalNumber: null,
        pin: false,
        isLocked: false,
        conditionItems: [],
        isRecordBodyPain: false
      },
      lockGoalOption: false,
      nonFieldError: ''
    }
  },
  computed: {
    memberId() {
      return this.$route.params.id
    },
  },
  async created() {
    this.$store.commit('startLoading')
    this.lockGoalOption = await this.$axios.get('/tenants/')
      .then((res) => res.data.lockGoalOption)
      .catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
    this.$store.commit('finishLoading')
  },
  methods: {
    async saveGoal(requestBody, isRepeat) {
      let isFailed = false
      this.$store.commit('startLoading')
      const goal = await this.$axios.post('/goals/', requestBody).then(res => res.data).catch((err) => {
        isFailed = true
        if (!err.response) {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          return
        }
        if (err.response.data.startDate || err.response.data.endDate) {
          this.nonFieldError = '実際に存在する日付を入力してください'
          return
        }
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      if (isRepeat) {
        await this.$axios.post(`/goals/${goal.id}/repeat_on/`).catch(() => {
          isFailed = true
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      }

      this.$store.commit('finishLoading')

      if (!isFailed) {
        this.$router.push(`/members/${this.memberId}?goalId=${goal.id}`)
        this.$store.commit('notify/set', {message: '新しいノートを追加しました。'})
        return
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.goal-lock-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  padding: 3px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &__icon {
    color: $grey11;
    &--locked {
      color: $black;
    }
  }
}

.repeat-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background-color: $white;
  padding: 3px;
  text-align: center;
  &__icon {
    cursor: pointer;
    width: 20px;
    height: auto;
  }
}

.goal-pin-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background-color: $white;
  padding: 3px;
  text-align: center;
  &__icon {
    width: 20px;
    height: auto;
  }
}

.edit-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    width: calc(100% - 422px);
    right: 0;
    left: auto;
  }
  &__icon{
    height: 22px;
    width: auto;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}

.form-group__sub-text {
  color: $grey04;
  font-size: $fs-m;
}

.condition {
  margin-bottom: 12px;

  .checkbox {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 5px;
    margin: 0 12px 0 8px;
    position: relative;
    transition: all 0.1s ease;

    &:checked::after {
      border-right: 3px solid $grey17;
      border-bottom: 3px solid $grey17;
      content: '';
      display: block;
      height: 15px;
      margin-top: -7px;
      position: absolute;
      top: 38%;
      left: 23%;
      transform: rotate(39deg);
      width: 11px;
    }

    &:disabled {
      background: $grey11;
    }
  }

  .label {
    font-weight: 600;
    width: 120px;
  }

  .unit {
    font-size: $fs-m;
  }
}
</style>